import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "44",
  height: "44",
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M44 22C44 34.1503 34.1503 44 22 44C9.84974 44 0 34.1503 0 22C0 9.84974 9.84974 0 22 0C34.1503 0 44 9.84974 44 22Z",
  fill: "#ffb500"
}, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M23.896 24.8243C23.8916 23.7427 23.0395 22.87 21.9945 22.8752C20.9488 22.8803 20.1055 23.761 20.1106 24.8426C20.1121 25.9235 20.9591 26.7984 22.0033 26.7984C22.2535 26.7973 22.5009 26.7457 22.7307 26.6468C22.9605 26.5479 23.168 26.4037 23.3409 26.2227C23.6973 25.8496 23.8953 25.3528 23.893 24.8368L23.896 24.8243Z",
  fill: "white"
}, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M21.8742 8.00001C23.7038 7.99708 25.4667 8.71352 26.8043 10.0049C28.1543 11.3571 28.9015 13.2285 28.8685 15.1718V15.545C28.7607 16.0437 28.3332 16.3971 27.8397 16.3971C27.3462 16.3971 26.9187 16.0429 26.8109 15.545V15.1659C26.8109 12.3207 24.6593 10.1765 21.8053 10.1765C18.8757 10.1765 16.5805 12.3522 16.5805 15.1498V17.093H28.4484C30.9607 17.1004 32.9949 19.2064 33 21.806V29.6891C32.9949 32.2887 30.9599 34.394 28.4484 34.3991H15.5546C13.0423 34.394 11.0066 32.2887 11 29.6891V21.806C11.0051 19.6266 12.4622 17.7391 14.5155 17.2522V15.1498C14.5059 13.1779 15.3148 11.297 16.7359 9.98361C18.1093 8.71337 19.9097 8.0054 21.7804 8.00001H21.8742ZM21.9916 20.7457H22.0062C23.9568 20.797 25.5811 22.3083 25.837 24.3095C26.093 26.3107 24.9035 28.2071 23.0336 28.782V30.3828C22.9478 30.8074 22.6273 31.1388 22.2167 31.2283C22.0817 31.2587 21.9419 31.2612 21.8059 31.2354C21.67 31.2097 21.5407 31.1564 21.4262 31.0787C21.1915 30.9232 21.0258 30.6776 20.9671 30.3953V28.7908C19.0825 28.2283 17.8777 26.3247 18.1344 24.3125C18.391 22.3003 20.03 20.7845 21.9916 20.7457Z",
  fill: "white"
}, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default render